$shm_hitalama_components_drafts_preview $mol_page
	model $shm_hitalama_components_drafts_model
	selected \
	editing? false
	close? null
	title <= draft_title \
	minimal_width 480
	tools /
		^ edit_tools /$mol_view
			<= Edit $mol_check_icon
				hint \Редактировать черновик
				checked? <=> editing?
				Icon <= Edit_icon $mol_icon_pencil
		<= Close $mol_button_minor
			hint \Закрыть черновик
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Content $shm_hitalama_text
			text <= text \
